import { makeStyles } from "@material-ui/core/styles";
import myTheme from "../../themes/palette";
// require('../../themes/fonts')
const useStyles = makeStyles((theme) => {
  return {
    menuButton: {
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(0.8),
      display: "flex",
      [theme.breakpoints.up(myTheme.breakpoints.values.xmd)]: {
        display: "none",
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        marginRight: theme.spacing(0),
        marginLeft: theme.spacing(0),
        paddingLeft:7
      },
    },
    badge:{
      borderRadius:'50%',
      color:'white',
      backgroundColor:myTheme.palette.primary.main,
      paddingLeft:5,
      paddingRight:5
    },
    header: {
      flexGrow: 1,
      // position: '-webkit-sticky',
      // position: 'sticky',
      // top: 20,
      // bottom: 20,
    },
    shopCategoriesDropDown:{
      marginTop: 31,
      height: 600,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        height:320
      },
    },
    appBar: {
      backgroundColor: "#fff",
      position: "fixed",
      color: myTheme.palette.secondary.main,
      boxShadow: "1",
      paddingTop: theme.spacing(1.2),
      paddingBottom: theme.spacing(0),
      boxShadow: "none",
      shadows: ["none"],
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        paddingTop: theme.spacing(0),
        paddingBottom: theme.spacing(0),
      },
      marginBottom: 126,
      [theme.breakpoints.down(myTheme.breakpoints.values.xmd)]: {
        marginBottom: 164,
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        marginBottom: 151,
      },
    },
    notificationMenu:{
        width: '100%',
        height: 400,
        maxWidth: 300,
        backgroundColor: theme.palette.background.paper,
    },

    logo: {
      width: "150px",
      marginLeft: theme.spacing(myTheme.padding.left),
      [theme.breakpoints.down(myTheme.breakpoints.values.xmd)]: {
        marginLeft: theme.spacing(1),
        margin: "auto",
        textAlign: "center",
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        marginLeft: 5,
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        width: "100px",
      },
    },
    categoriesDropBtn: {
      textTransform: "none",
      //marginLeft: theme.spacing(15),
      borderTopLeftRadius: theme.shape.borderRadius,
      borderBottomLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderColor: myTheme.palette.secondary.light,
      //m: 1,
      border: "1px solid",
      paddingRight: 13,
      paddingTop: theme.spacing(0.65),
      paddingBottom: theme.spacing(0.65),
      [theme.breakpoints.down("xs")]: {
        marginLeft: theme.spacing(2),
      },
      [theme.breakpoints.down(1060)]: {
        display: "none",
      },
    },
    categoriesDropBtnMobile:{
      textTransform: "none",
      //marginLeft: theme.spacing(15),
      borderTopLeftRadius: theme.shape.borderRadius,
      borderBottomLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderColor: myTheme.palette.secondary.light,
      //m: 1,
      paddingTop: theme.spacing(0.65),
      paddingBottom: theme.spacing(0.65),
      width:10,
      
    },
    searchBar: {
      display: "flex",
      textAlign: "center",
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
      [theme.breakpoints.down(myTheme.breakpoints.values.xmd)]: {
        display: "none",
      },
    },
    searchBarMobile: {
      position: "relative",
      display: "flex",
      marginTop: theme.spacing(0),
      marginLeft: theme.spacing(1.5),
      marginRight: theme.spacing(1.5),
      justifyContent: "center",
      margin: "auto",
      [theme.breakpoints.up(myTheme.breakpoints.values.xmd)]: {
        display: "none",
      },
    },
    searchBtn: {
      textTransform: "none",
      backgroundColor: myTheme.palette.primary.main,
      color: myTheme.palette.primary.contrastText,
      borderTopRightRadius: theme.shape.borderRadius,
      borderBottomRightRadius: theme.shape.borderRadius,
      borderTopLeftRadius: 0,
      paddingLeft: 20,
      paddingRight: 20,
      borderBottomLeftRadius: 0,
      borderColor: myTheme.palette.secondary.light,
      paddingTop: 6.5,
      paddingBottom: 6.5,
      "&:hover": {
        backgroundColor: myTheme.palette.primary.dark,
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        paddingLeft: 10,
        paddingRight: 10,
        paddingTop: 3,
        paddingBottom: 3,
      },
    },

    search: {
      position: "relative",
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      backgroundColor: myTheme.palette.primary.contrastText,
      // "&:hover": {
      //   backgroundColor: myTheme.palette.secondary.light,
      // },
      border: "1px solid",
      borderColor: myTheme.palette.secondary.light,
      width: "100%",
      display:'flex',
      [theme.breakpoints.up("sm")]: {
        width: "60%",
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        width: "80%",
        borderTopLeftRadius: 3,
        borderBottomLeftRadius: 3,
      },
    },
    searchIcon: {
      padding: theme.spacing(0, 1),
      height: "100%",
      position: "absolute",
      pointerEvents: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: myTheme.palette.secondary.light,
    },
    searchIconMobile: {
      padding: theme.spacing(0, 1),
      height: "100%",
      // position: "absolute",
      // pointerEvents: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: myTheme.palette.secondary.light,
    },
    inputRoot: {
      color: "inherit",
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create("width"),
      width: "100%",
      [theme.breakpoints.up("md")]: {
        // width: "70%",
      },
    },
    inputInputMobile: {
      // vertical padding + font size from searchIcon
      height:'100%',
      alignItems:'center',
      width: "100%",
      maxWidth:150,
      overFlow:'hidden',
      textTransform:'ellipsis',
      whiteSpace:'noWrap',
      transition: theme.transitions.create("width"),
      [theme.breakpoints.up("md")]: {
        // width: "70%",
      },
    },
    sectionDesktop: {
      display: "none",
      marginRight: theme.spacing(myTheme.padding.right),
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    moreIconForMobile:{
      paddingRight:2
    },
    sectionMobile: {
      display: "flex",
      paddingRight:0,
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    grow: {
      flexGrow: 1,
    },
    customIconButton: {
      margin: theme.spacing(0.8),
    },

    //PAGES NAVIGATION BAR
    navigationBar: {
      marginTop: 10,
      display: "flex",
      paddingTop: theme.spacing(0.2),
      paddingBottom: theme.spacing(0.2),
      backgroundColor: myTheme.palette.primary.main,
      paddingLeft: theme.spacing(myTheme.padding.left + 3.5),
      //paddingRight: theme.spacing(myTheme.padding.right),
      direction: "row",
      alignItems: "center",
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        paddingLeft: theme.spacing(myTheme.padding.left - 9),
        paddingRight: theme.spacing(myTheme.padding.right - 9),
      },

      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        paddingLeft: theme.spacing(myTheme.padding.left - 11.6),
        paddingRight: theme.spacing(myTheme.padding.right - 11.6),
      },
    },
    shopByDepartmentBtn: {
      textTransform: "none",
      backgroundColor: myTheme.palette.primary.dark,
      color: myTheme.palette.primary.contrastText,
      borderTopRightRadius: theme.shape.borderRadius,
      borderBottomRightRadius: theme.shape.borderRadius,
      borderTopLeftRadius: 0,

      paddingLeft: 20,
      paddingRight: 20,
      height: "40px",
      justifyContent: "flex-start",
      borderBottomLeftRadius: 0,
      borderColor: myTheme.palette.secondary.light,
      // paddingTop: 6.5,
      // paddingBottom: 6.5,
      "&:hover": {
        backgroundColor: myTheme.palette.primary.dark,
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        paddingLeft: 3,
        paddingRight: 3,
        marginRight: 4,
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.xmd)]: {
        width: "100%",
        paddingLeft: 3,
        //justifyContent:'center',
        margin: "auto",
        paddingLeft: theme.spacing(2.2),
        paddingRight: theme.spacing(2),
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        paddingLeft: theme.spacing(1.3),
        marginLeft: 2.2,
        marginRight: 2.2,
        padding: 0,
        height:37
      },
    },
    expandMoreBtnShopByDept: {
      marginLeft: 16,
      [theme.breakpoints.down(myTheme.breakpoints.values.xmd)]: {
        position: "absolute",
        right: theme.spacing(2.2),
        //left:'93%'
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        position: "absolute",
        right: theme.spacing(1.5),
        //left:'93%'
      },
    },
    shopDeptText: {
      marginLeft: 0,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        fontSize:16
      },
    },
    NavLinksBox: {
      marginLeft: 40,
      [theme.breakpoints.down(myTheme.breakpoints.values.lg)]: {
        marginLeft: 20,
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.xmd)]: {
        display: "none",
      },
    },
    navLinkBtn: {
      paddingLeft: 5,
      paddingRight: 5,
      paddingTop: 1,
      paddingBottom: 1,
      backgroundColor: "transparent",
      border: "none",
      justifyContent: "center",
      margin: "auto",
      color: myTheme.palette.primary.contrastText,
      marginRight: 27,
      "&:hover": {
        backgroundColor: myTheme.palette.primary.dark,
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.lg)]: {
        marginRight: 12,
      },
    },
    navLinkText: {
      textTransform: "none",
      textDecoration: "none",
      textAlign: "center",
      fontFamily: "inherit",
      fontSize: "inherit",
      fontWeight: "bold",
      fontSize: 18,
      borderBottom: "none",
      //padding: 1,
      color: myTheme.palette.primary.contrastText,
      backgroundColor: "transparent",
      // "&:hover": {
      //   backgroundColor: myTheme.palette.primary.dark,
      // },
    },

    //SIDE DRAWER
    list: {
      width: 250,
      marginTop: 40,
    },
    fullList: {
      width: "auto",
    },
    collapseList: {
      paddingTop: theme.spacing(1),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      width: "100%",
    },

    HeaderLinksHeadingText:{
      padding:5,
      marginLeft:10,
      whiteSpace:'initial',
      maxWidth:'301px'
    },

    //HOVER BOXES
    shopCategoriesGridBox: {
      //marginLeft:580,
      boxShadow: " 0 3px 10px rgb(0 0 0 / 0.2);",
      padding: 20,
      [theme.breakpoints.down(myTheme.breakpoints.values.md)]: {
        display: "none",
      },
    },
    shopByDeptMenu: {
      marginTop: "124px",
      height: 600,
      [theme.breakpoints.down(myTheme.breakpoints.values.xmd)]: {
        marginTop: "148px",
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        marginTop: "136px",
        height:400
      },
    },
    notificationMenu: {
      marginTop: "60px",
      height: 500,
      textAlign:'justify',
      paddingBottom:20,
      [theme.breakpoints.down(myTheme.breakpoints.values.xmd)]: {
        marginTop: "90px",
      },
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        marginTop: "50px",
      },
    },
    menuCategoiesSearchBar:{
      marginTop:45,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        height:350
      },
    },
    notificationItemBox:{
      width: 380,
      [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
        width: 330,
      },
    }
  };
});

export default useStyles;
